module.exports = __webpack_public_path__ + "static/media/organizer_5.d7a4504e.jpg";